export enum EServiceType {
  /** Бесплатная публикация */
  free = 'free',
  /** Платная публикация */
  paid = 'paid',
  /** Премиум публикация */
  premium = 'premium',
  /** Колтрекинг */
  calltracking = 'calltracking',
  /** Аукцион */
  auction = 'auction',
  /** Топ */
  top3 = 'top3',
}
